import { IdentityVerificationStatuses } from './identity-verification'
import { ProductBundleDTO } from './product-bundle'
import { SelfAssessmentSimpleDTO } from './self-assessment'
import { SubscriptionDTO, SubscriptionStatus } from './subscription'
import { TaxConsultation } from './tax-consultation'

export enum ExternalApis {
    Hmrc = 'Hmrc',
    Rollee = 'Rollee',
    ExpoPushToken = 'ExpoPushToken',
}

export interface ProfileDTO {
    accountantId: number | null
    accountantUseIdentityVerification: boolean
    acquisitionDateUTC: string | null
    addressCity: string | null
    addressCountry: string | null
    addressPostcode: string | null
    addressStreetAddress: string | null
    agentAuthorisationStatus: string | null // @TODO: enum
    availableDiscountPercentage: number | null
    availableSelfAssessmentDiscountPercentage: number | null
    availableSubscriptionDiscountPercentage: number | null
    availableTaxConsultationDiscountPercentage: number | null
    canContactAccountant: boolean
    changeNameDate: string | null
    dateOfBirth: string | null
    email: string
    externalApis: ExternalApis[]
    firstName: string | null
    hasPendingSubscriptionWelcomeCall: boolean
    hasNoNationalInsuranceNumber: boolean
    hmacToken: string | null
    id: number
    identityVerificationStatus: IdentityVerificationStatuses
    initialVariant: string | null
    lastName: string | null
    maritalStatus: string | null // @TODO: enum
    md5HashedEmail: string | null
    nationalInsuranceNumber: string | null
    numberOfUnreadMessages: number
    phoneNumber: string | null
    previousLastName: string | null
    productBundles: ProductBundleDTO[]
    referralSchemeCode: string | null
    referralSource: string | null
    selfAssessments: SelfAssessmentSimpleDTO[]
    selfEmployedPlatformEnabled: boolean | null
    subscriptions: SubscriptionDTO[] | null
    subscriptionStatus: keyof typeof SubscriptionStatus | null
    taxConsultations: TaxConsultation[]
    taxRegistrationStatus: string | null // @TODO: enum
    uniqueTaxpayerReference: string | null
    variant: string | null
}

export interface Profile extends ProfileDTO {
    fullName: string
    hasPaidTaxConsultations: boolean
    hasProductBundles: boolean
    hasSelfAssessments: boolean
    hasSubmittedSelfAssessments: boolean
    hasTaxConsultations: boolean
    hasTaxReliefClaims: boolean
    isReturningCustomer: boolean
    isReturningSelfAssessmentCustomer: boolean
    numberOfPaidServices: number
    selfDeclaredAttributionSource: string | null
}

export interface ProfileSlice extends Profile {
    fetchSuccessful: boolean | null
}
